import React, {PureComponent} from 'react';
import {Field, reduxForm} from 'redux-form';

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';

import Input from "../../Form/Field/Input.jsx";
import {Plus} from "react-feather";
import CardCol from "../../Styled/Card/CardCol.jsx";
import CardRow from "../../Styled/Card/CardRow.jsx";

import './ItSkillForm.scss';
export const name = 'ItSkillForm';

class ItSkillForm extends PureComponent {
  handleSubmit = (values) => {
    const subResult = this.props.handleSubmit(values);
    if (!subResult.then) {
      return subResult;
    }
    return subResult
      .then((data) => {
        this.props.reset()
        return data;
      })
    ;
  };

  render() {

    return (
      <div id={name} className="it-skill-form">
        <form autoComplete="off" onSubmit={this.handleSubmit}>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
          <CardRow align="flex-end" gap="20px">
            <CardCol flex={1} className="formations-form-field-col">
              <Field
                label="Outils"
                name="name"
                placeholder=""
                component={Input}/>
            </CardCol>

            <CardCol>
              <button type="submit" className="mb-3 btn btn-outline-primary">
                <Plus/> Ajouter
              </button>
            </CardCol>
          </CardRow>
        </form>
      </div>
    )
  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name)
})(ItSkillForm);